// extracted by mini-css-extract-plugin
module.exports = {"HorizontalScrollClippedContent":"HorizontalScrollClippedContent__1Ix_j"};